import React, { ReactElement } from "react";
import Skeleton from "react-loading-skeleton";
import { Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";

interface BasePanelProps {
  isOpen: boolean;
  onClose?: () => void;
  position?: "start" | "end" | "top" | "bottom";
  size?: string;
  children: ReactElement;
  headerButtons?: ReactElement;
  title: string;
  subTitle?: string;
  loader?: boolean;
}

const BasePanel: React.FC<BasePanelProps> = ({
  isOpen,
  onClose,
  position = "end",
  size = "300px",
  children,
  headerButtons,
  loader,
  title,
  subTitle,
}) => {
  const drawerStyle = {
    width: position === "start" || position === "end" ? size : "100%",
    height: position === "top" || position === "bottom" ? size : "100%",
  };

  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={onClose}
      direction={position}
      style={drawerStyle}
    >
      {loader ? (
        <Skeleton height={80} />
      ) : (
        <div className="border-bottom offcanvas-header">
          {title && (
            <>
              <h5 className="mb-0">{title}</h5>
              <div>{subTitle}</div>
            </>
          )}
          <div className="d-flex gap-2">
            {headerButtons}
            <i
              className="mdi mdi-close fs-4 cursor-pointer"
              onClick={onClose}
            ></i>
          </div>
        </div>
      )}
      <OffcanvasBody>
        {loader ? <Skeleton height={450} /> : children}
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default BasePanel;
